import { useDatabase } from "./DatabaseContext";
import { useMainAccessors } from "./useMainAccessors";

export const CHARACTERS_COLLECTION = "pico-characters";
const CHARACTERS_PATH = [CHARACTERS_COLLECTION];

export const useCharactersAccessors = () => {
  const db = useDatabase();
  return useMainAccessors(db, CHARACTERS_PATH);
};
